import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faShieldAlt, faSolarPanel, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import Navbar from '../../../components/Navbar';
import { Helmet } from 'react-helmet-async';
import DragupButton from '../../../components/DragupButton';
import Footer from '../../../components/Footer';
import './Landestation.css';
import imgSMA from '../../../images/P24.webp';

function Landestation() {
  return (
    <>
      <Helmet>
        <title>Landestation | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/leistungen/landestation" />
      </Helmet>
      <DragupButton />
      <Navbar />

      <div className="landestation-container">
        {/* Hero Section */}
        <section className="landestation-hero-section">
          <div className="landestation-hero-text">
            <h1>SMA Wallbox-Lösungen – Effizientes Laden für eine nachhaltige Zukunft</h1>
            <p>
              Unsere innovativen SMA Wallbox-Lösungen bieten Ihnen weit mehr als nur eine praktische und sichere Möglichkeit, Ihr E-Auto zu laden. Sie stehen für Effizienz, modernste Technologie und Nachhaltigkeit. Mit ihrer intelligenten Steuerung und nahtlosen Integration in bestehende Energiesysteme – wie Ihre Photovoltaikanlage – maximieren sie Ihre Energieeffizienz und reduzieren Ihre Stromkosten.
            </p>
            <Link to="/contact" className="landestation-cta-button">Kontaktieren Sie uns für eine Beratung</Link>
          </div>
          <div className="landestation-hero-image">
            <img src={imgSMA} alt="Wallbox Ladestation" />
          </div>
        </section>

        {/* Features Section */}
        <section className="landestation-features-section">
          <h2>Warum eine intelligente Wallbox?</h2>
          <div className="landestation-features-grid">
            <div className="landestation-feature-item">
              <FontAwesomeIcon icon={faBolt} className="landestation-feature-icon" />
              <div>
                <strong>Effizienz:</strong>
                <p>Laden Sie Ihr Elektroauto deutlich schneller als mit herkömmlichen Steckdosen, und das mit optimalem Energieeinsatz.</p>
              </div>
            </div>
            <div className="landestation-feature-item">
              <FontAwesomeIcon icon={faShieldAlt} className="landestation-feature-icon" />
              <div>
                <strong>Sicherheit:</strong>
                <p>Modernste Schutzmechanismen garantieren ein sicheres Ladeerlebnis ohne Risiko für Ihr Zuhause.</p>
              </div>
            </div>
            <div className="landestation-feature-item">
              <FontAwesomeIcon icon={faSolarPanel} className="landestation-feature-icon" />
              <div>
                <strong>Energieintegration:</strong>
                <p>Nutzen Sie Ihre Wallbox in Kombination mit Solaranlagen, um nachhaltig und kostensparend zu laden.</p>
              </div>
            </div>
            <div className="landestation-feature-item">
              <FontAwesomeIcon icon={faMobileAlt} className="landestation-feature-icon" />
              <div>
                <strong>Zukunftsfähigkeit:</strong>
                <p>Mit smarten Funktionen wie App-Steuerung und Energiemanagementsystemen sind Sie bestens auf die Mobilität von morgen vorbereitet.</p>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default Landestation;